module.exports = __webpack_public_path__ + "img/historia.58b8c46e.jpg";